export default "__VITE_ASSET__80fd1c60__$_?nuxt_component=async&nuxt_component_name=SvgoFreetether__"